import { motion } from "framer-motion";
import {
  VEHICLE_SIZES,
  CONDITIONS,
  LOWERED,
} from "@/lib/quoteOptions";
import { TextInput, Select, RadioTiles } from "@/components/quote/Fields";

export default function StepVehicle({ data, update, onNext }) {
  const v = data.vehicle;
  const setV = (k, val) => update({ vehicle: { ...v, [k]: val } });

  const canNext =
    v.make.trim().length > 0 &&
    v.model.trim().length > 0 &&
    v.vehicle_size &&
    data.condition;

  return (
    <motion.div
      key="step-vehicle"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
      className="space-y-8"
    >
      <div>
        <div className="text-[10px] tracking-[0.3em] uppercase text-[#E60000] font-bold mb-3">
          Step 01 · Your Vehicle
        </div>
        <h1 className="font-display font-extrabold text-white text-3xl md:text-5xl leading-[1.05] tracking-tight">
          What are we
          <br />
          <span className="text-stroke">transporting?</span>
        </h1>
      </div>

      <TextInput
        label="Vehicle Registration (optional)"
        hint="Optional — just for our records"
        testId="quote-input-reg"
        placeholder="AB19 CDE"
        value={v.registration}
        onChange={(e) => setV("registration", e.target.value.toUpperCase())}
      />

      <div className="grid sm:grid-cols-2 gap-4">
        <TextInput
          label="Make *"
          testId="quote-input-make"
          placeholder="BMW"
          value={v.make}
          onChange={(e) => setV("make", e.target.value)}
        />
        <TextInput
          label="Model *"
          testId="quote-input-model"
          placeholder="M3 Competition"
          value={v.model}
          onChange={(e) => setV("model", e.target.value)}
        />
      </div>
      <div className="grid sm:grid-cols-2 gap-4">
        <TextInput
          label="Year"
          testId="quote-input-year"
          placeholder="2019"
          inputMode="numeric"
          value={v.year}
          onChange={(e) => setV("year", e.target.value.replace(/\D/g, "").slice(0, 4))}
        />
        <Select
          label="Vehicle type *"
          testId="quote-input-size"
          value={v.vehicle_size}
          onChange={(e) => setV("vehicle_size", e.target.value)}
          options={VEHICLE_SIZES}
        />
      </div>

      <div className="pt-2">
        <RadioTiles
          label="Condition *"
          hint="Non-runners are no problem — our transporters have winches. Seized vehicles may need a custom quote."
          testId="quote-condition"
          value={data.condition}
          onChange={(v) => update({ condition: v })}
          options={CONDITIONS}
          columns={1}
        />
      </div>

      <div>
        <RadioTiles
          label="Is the vehicle significantly lowered or very low?"
          hint="Low vehicle? No problem — tilt-bed and low-loading options are available."
          testId="quote-lowered"
          value={data.lowered}
          onChange={(v) => update({ lowered: v })}
          options={LOWERED}
          columns={3}
        />
      </div>

      <div className="flex justify-end pt-2">
        <button
          type="button"
          onClick={onNext}
          disabled={!canNext}
          data-testid="quote-vehicle-next"
          className="btn-primary disabled:opacity-40 disabled:cursor-not-allowed"
        >
          Continue
        </button>
      </div>
    </motion.div>
  );
}
